/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
var Alert =
/*#__PURE__*/
function () {
  function Alert() {}

  Alert.alert = function alert() {};

  return Alert;
}();

export default Alert;